import { Tooltip } from "react-bootstrap";
import { Show } from "../../hooks/Show";

const Header = ({ title, subtitle, actionButtons }) => {
    const renderTooltip = (title) => <Tooltip id='button-tooltip'>{title}</Tooltip>;

    const renderBtns = () => {
        if (!actionButtons)
            return null;

        const renderButton = (ele, index) => (
            <div key={index} className="mx-1">
                <button
                    title={ele.description}
                    className={`btn ${ele.buttonType} btn-circle`}
                    type="button"
                    disabled={ele.disabled}
                    onClick={ele.disabled ? undefined : ele.onClick}
                >
                    {ele.loading
                        ? <span
                            className="spinner-border spinner-border-sm"
                            style={{ width: '1rem', height: '1rem', borderWidth: '0.2em', borderRadius: '50%', flexShrink: 0, aspectRatio: '1 / 1' }}
                        ></span>
                        : <i className={`${ele.buttonIcon}`}></i>}
                </button>
            </div>
        )

        const buttons = actionButtons.map((ele, index) => {
            if (ele.permission) {
                return (
                    <Show key={index} when={ele.permission}>
                        {renderButton(ele, index)}
                    </Show>
                )
            } else {
                return renderButton(ele, index)
            }
        });

        return buttons;
    }

    return (<>
        <div className="d-sm-flex align-items-center my-2">
            <h1 className="h3 mb-0 text-gray-800 mr-3">{title}</h1>
            {
                renderBtns()
            }
        </div>
        {
            subtitle && <p>{subtitle}</p>
        }

    </>);
}

export default Header;